export enum Consent {
  Essential = 'C0001',
  FunctionalAndPerformance = 'C0002',
  AdvertisingAndMarketing = 'C0005',
}

export const hasCookieConsent = (key: Consent) => {
  const activeGroups = (window.OnetrustActiveGroups || '').split(',')
  const hasConsent = activeGroups.includes(key)

  return hasConsent
}
